import React, {useEffect, useRef, useState} from "react";
import moment from "moment-timezone";
import ReactTooltip from "react-tooltip";
import {DateRangePicker} from "react-dates";

import { Row } from "../../components/Layout";
import CSVExporter from "components/Table/CSVExporter";
import NTMButton from "../../components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import NTMTable from "../../components/Table/NTMTable";
import InfoCell from "../../components/Layout/InfoCell";

import {get} from "../../service/Client";
import {useGetDevices} from "../../service/AgrismartService";
import styles from "./_agrismart.module.scss";

export default function ReviewPage() {

	let {devices} = useGetDevices()
	let [device, setDevice] = useState();
	let [interval, setIntvl] = useState("daily");
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	let [focusedInput, setFocusedInput] = useState();
	let [data, setData] = useState([])
	let [aggregates, setAggregates] = useState({})
	let buttonRef = useRef();

	useEffect(getData, [device, interval, startDate, endDate]);
	if(devices.length === 0) return <div/>
	if(!device) {
		setDevice(devices[0].device)
	}

	function getData() {
		let start;
		let end = moment();
		if(interval === "daily") {
			start = end.clone();
		} else if(interval === "weekly") {
			start = end.clone().subtract(7, 'days');
		} else if( interval === "monthly") {
			start = end.clone().subtract(1, "months")
		} else if (startDate !== null && endDate !== null) {
			start = moment(startDate);
			end = moment(endDate);
		} else return;
		get(`agrismart/${device}/statistics`, {params:{start:start.format("DD-MM-YYYY"),end:end.format("DD-MM-YYYY")}}).then(d => {
			let data = [];
			data.push({
				type:"min",
				...d.min
			});
			data.push({
				type:"media",
				...d.avg
			});
			data.push({
				type:"max",
				...d.max
			});
			setData(data);
			setAggregates({
				totalRainfall: d.avg.totalRainfall,
				coldHours: d.avg.coldHours,
				hotHours: d.avg.hotHours,
				wetHours: d.avg.wetHours,
				lightHours: d.avg.lightHours,
				degreesHours: d.avg.ticchiolaturaHoursTemperature,
			})
		})
	}

	function toCSV(data) {
		return data.map(d => {
			return {
				"valori":d.type,
				"Temp. esterna": d.mediumExternalTemperature,
				"Temp suolo 1": d.mediumSoilTemperature,
				"Temp suolo 2": d.mediumSoilTemperature2,
				"Hum atmosf": d.mediumExternalHumidity,
				"Hum suolo 1": d.mediumSoilHumidity,
				"Hum suolo 2": d.mediumSoilHumidity2,
				"Bagnatura fogliare": d.mediumLeafHumidity,
				"Piovosita": d.mediumRainfall,
				"Radiazione solare": d.mediumSolarRadiation,
				"Temp esterna 2": d.mediumExternalTemperature2,
				"Hum atmosf 2": d.mediumExternalHumidity2,
				"Vel Vento": d.mediumWindSpeed,
				"Pressione": d.mediumExternalPressure,
			}
		})
	}

	function getValue(field) {
		return field || field === 0 ? `${+field.toFixed(2)}` : "-"
	}

	return <div className="animated fadeIn">
		<Row className={styles.box}>
			<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
				{devices.map(d =>
					<option key={d.device} value={d.device}>{d.label || d.device}</option>
				)
				}
			</NTMSelect>
			<NTMButton
				primary={interval === "daily"}
				unselected={interval !== "daily" ? 'true' : undefined}
				onClick={() => setIntvl("daily")}
			>Oggi</NTMButton>
			<NTMButton
				primary={interval === "weekly"}
				unselected={interval !== "weekly" ? 'true' : undefined}
				onClick={() => setIntvl("weekly")}
			>Ultimi 7 gg</NTMButton>
			<NTMButton
				primary={interval === "monthly"}
				unselected={interval !== "monthly" ? 'true' : undefined}
				onClick={() => setIntvl("monthly")}
			>Ultimi 30 gg</NTMButton>

			<div data-tip data-for='global' data-event='click' ref={buttonRef}>
				<NTMButton
					primary={interval === "custom"}
					unselected={interval !== "custom" ? 'true' : undefined}
				>
					{
						startDate ?
							`${moment(startDate).format("DD/MM/YYYY")}
											-
							${moment(endDate).format("DD/MM/YYYY")}`
							: <>Scegli Periodo&nbsp;<i className="fa fa-caret-down"
							                           aria-hidden="true"/></>
					}
				</NTMButton>
			</div>
			<ReactTooltip
				id='global'
				aria-haspopup='true'
				effect='solid'
				place={"bottom"}
				clickable
				getContent={() => <DateRangePicker
					startDate={startDate} // momentPropTypes.momentObj or null,
					startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
					endDate={endDate} // momentPropTypes.momentObj or null,
					endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
					onDatesChange={({startDate, endDate}) => {
						setIntvl("custom")
						setStartDate(startDate)
						setEndDate(endDate)
						if (startDate !== null && endDate !== null) {
							buttonRef.current.click();
						}
					}} // PropTypes.func.isRequired,
					focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
					onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
					withPortal={true}

					startDatePlaceholderText={"Inizio"}
					endDatePlaceholderText={"Fine"}
					displayFormat={"DD/MM/YYYY"}
					isOutsideRange={(o) => o.isAfter(moment(), 'day')}
					small={true}
				/>}
			/>
		</Row>
		<div style={{ margin: "1rem auto"}}>
			<CSVExporter title={"Scarica"} name={"Agrismart"} data={toCSV(data)}/>
			<NTMTable
				header={[
					{
						Header: "Valori",
						accessor: 'type',
						Cell: props => <div style={{color:"#AB2430", textTransform:"uppercase", fontWeight:"bold"}}>{props.original.type}</div>
					},
					{
						Header: "Temp. est 1",
						accessor: 'mediumExternalTemperature',
						Cell: props => <div>{`${getValue(props.original.mediumExternalTemperature)}°`}</div>
					},
					{
						Header: "temp. suolo 1",
						accessor: 'mediumSoilTemperature',
						Cell: props => <div>{`${getValue(props.original.mediumSoilTemperature)}°`}</div>
					},
					{
						Header: "temp. suolo 2",
						accessor: 'mediumSoilTemperature2',
						Cell: props => <div>{`${getValue(props.original.mediumSoilTemperature2)}°`}</div>
					},
					{
						Header: "Hum atm 1",
						accessor: 'mediumExternalHumidity',
						Cell: props => <div>{`${getValue(props.original.mediumExternalHumidity)}%`}</div>
					},
					{
						Header: "Hum suolo",
						accessor: 'mediumSoilHumidity',
						Cell: props => <div>{`${getValue(props.original.mediumSoilHumidity)} cb`}</div>
					},
					{
						Header: "Hum suolo 2",
						accessor: 'mediumSoilHumidity2',
						Cell: props => <div>{`${getValue(props.original.mediumSoilHumidity2)} cb`}</div>
					},
					{
						Header: "umidità fogliare",
						accessor: 'mediumLeafHumidity',
						Cell: props => <div>{`${getValue(props.original.mediumLeafHumidity)}%`}</div>
					},
					{
						Header: "Piovosità",
						accessor: 'mediumRainfall',
						Cell: props => <div>{`${getValue(props.original.mediumRainfall)} mm`}</div>
					},
					{
						Header: "Radiazione solare",
						accessor: 'mediumSolarRadiation',
						Cell: props => <div>{`${getValue(props.original.mediumSolarRadiation)} W/mq`}</div>
					},
				]}
				body={data}
				defaultPageSize={3}
				showPagination={false}
			/>
		</div>
		<div style={{ margin: "1rem auto"}}>
			<NTMTable
				header={[
					{
						Header: "Valori",
						accessor: 'type',
						Cell: props => <div style={{color:"#AB2430", textTransform:"uppercase", fontWeight:"bold"}}>{props.original.type}</div>
					},
					{
						Header: "Temp. est 2",
						accessor: 'mediumExternalTemperature',
						Cell: props => <div>{`${getValue(props.original.mediumExternalTemperature2)}°`}</div>
					},
					{
						Header: "Hum atm 2",
						accessor: 'mediumExternalHumidity',
						Cell: props => <div>{`${getValue(props.original.mediumExternalHumidity2)}%`}</div>
					},
					{
						Header: "Vento (vel)",
						accessor: 'mediumWindSpeed',
						Cell: props => <div>{`${getValue(props.original.mediumWindSpeed)} km/h`}</div>
					},
					{
						Header: "Pressione",
						accessor: 'mediumExternalPressure',
						Cell: props => <div>{`${getValue(props.original.mediumExternalPressure)} hPa`}</div>
					},
				]}
				body={data}
				defaultPageSize={3}
				showPagination={false}
			/>
		</div>
		<div>
			<InfoCell name={"millimetri di pioggia"} value={aggregates.totalRainfall} um={" mm"}/>
			<InfoCell name={"ore di freddo"} value={aggregates.coldHours} um={" ore"}/>
			<InfoCell name={"ore di caldo"} value={aggregates.hotHours} um={" ore"}/>
			<InfoCell name={"ore di bagnatura"} value={aggregates.wetHours} um={" ore"}/>
			<InfoCell name={"ore di luce"} value={aggregates.lightHours} um={" ore"}/>
			<InfoCell name={"gradi ora"} value={aggregates.degreesHours} um={" °ora"}/>
		</div>
	</div>
}
